<template>
  <div id="overlay">
    <div class="center w-6/12">
      <div
        class="content border border-1 border-solid bg-white p-5 flex flex-col"
      >
        <div class="text-gray-800 text-3xl my-auto">
          {{ type.name}}{{ " Field" }}
        </div>
        <div class="text-gray-800 text-3 my-auto flex mt-4">
          <div class="col-3 input-effect w-full">
            <input
              class="effect-16 w-full"
              type="text"
              placeholder="Enter your field name*"
              v-model="row.name"
              @input="changeName()"
            />
            <span class="focus-border w-full"></span>
          </div>
          <div class="col-3 input-effect w-full pl-2">
            <LvColorpicker
              placeholder="Choose your color"
              v-model="row.color"
              clearable
            />
          </div>
        </div>
        <div class="w-full flex justify-end p-3 cursor-default">
          <div class="flex flex-row" style="width: 300px">
            <button
              class="m-1 w-full h-12 rounded-sm bg-button label text-whiteText text-xs"
              @click="$emit(type.method, [row]); $emit('close');"
              :disabled="empty"
            >
              Save
            </button>
            <button
              class="m-1 w-full h-12 rounded-sm bg-button label text-whiteText text-xs"
              @click="$emit('close')"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LvColorpicker from "lightvue/color-picker";
export default {
  data() {
    return {
      empty:false,
    };
  },

  watch: {},
  methods: {
    changeName(){
      if(this.row.name && this.row.name!=''){
        this.empty=false;
      }else{
        this.empty=true;
      }
    }
  },

  created() {
    if(this.row.color==null || this.type.name=='Add'){
      this.empty=true;
      this.row.color='';
    }
    if(this.row.name==null || this.type.name=='Add'){
      this.empty=true;
      this.row.name='';

    }
  },

  components: {
    LvColorpicker: LvColorpicker,
  },
  props: {
    row: Object,
    type: Object,
  },
};
</script>
